import React, { useEffect, useState } from 'react'
import Switch from 'react-switch'
import { Col, FormGroup, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'

const WheatPastaPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    WholeWheatFlour: item.WholeWheatFlour,
  })
  const methods = useFormContext()
  const { setSwitchReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item) {
      const { FatLevel, Type, WholeWheatFlour } = item
      setPackaging({
        FatLevel,
        Type,
        WholeWheatFlour,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that &quot;whole wheat flour&quot; and/or &quot;whole
              durum wheat flour&quot; are the only flours listed in the
              ingredients list. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="WholeWheatFlour"
            id="WholeWheatFlour"
            defaultValue={packaging.WholeWheatFlour}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            checked={packaging.WholeWheatFlour}
            rules={{ validate: WholeWheatFlour => WholeWheatFlour === true }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="WholeWheatFlour"
              message={
                '⚠ You must certify that this product meets the flour requirement.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

WheatPastaPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default WheatPastaPackageReview
